export const CONTACT_EMAIL = "manvinder.randhawa@ibyvision.com";
export const CONTACT_LOCATION = "Glen Waverley, Victoria, Australia";

export const SOCIAL_LINKS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/ibyvisionfoundation/",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/inspired-by-you-program/?viewAsMember=true",
  },
];
